// extracted by mini-css-extract-plugin
export default {"white":"hsl(0, 0%, 100%)","star":"Star--star--8b47e0","big":"Star--big--d05a1d","medium":"Star--medium--f03162","small":"Star--small--76138e"};